// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1JgY6","actions":"GroupTable_actions__3Gm5f","deleteModalFooter":"GroupTable_deleteModalFooter__27wb4"};